import { jsx as _jsx } from "react/jsx-runtime";
import { DocumentContextProvider } from '../../contexts/DocumentContext';
import { DpdContextProvider } from '../../contexts/DpdContext';
import { EipdContextProvider } from '../../contexts/EipdContext';
import { FormProgressContextProvider } from '../../contexts/FormProgressContext';
import { FormResponseContextProvider } from '../../contexts/FormResponseContext';
import { GlobalProvider } from '../../contexts/GlobalProviderContext';
import { UserProfileProvider } from '../../contexts/new/UserProfileContextX';
import dataJson from '../../data/formModel.json';
import ProtectedRoutes from './ProtectedRoutes';
const FormRoutes = ({ children }) => {
    const data = dataJson;
    return (_jsx(ProtectedRoutes, { children: _jsx(GlobalProvider, { children: _jsx(UserProfileProvider, { children: _jsx(FormResponseContextProvider, { children: _jsx(FormProgressContextProvider, Object.assign({ sectionsData: data.sections }, { children: _jsx(DocumentContextProvider, { children: _jsx(EipdContextProvider, { children: _jsx(DpdContextProvider, { children: children }) }) }) })) }) }) }) }));
};
export default FormRoutes;
